export default __webpack_public_path__ + "static/l-shape-social-9c3c310c4faaa272ed5d5e0347dc6cf5.png";